import './Services.css'

interface ServiceCard {
  id: string
  title: string
  description: string
  features: string[]
  icon: string
}

interface ServicesProps {
  onBookService: (serviceId: string) => void
}

const services: ServiceCard[] = [
  {
    id: 'party',
    title: 'Party Sound Services',
    description: 'Professional sound equipment and music selection for any party or event.',
    features: [
      'Custom playlists tailored to your event',
      'High-quality speakers and sound system',
      'Professional DJ services',
      'Multiple music genres available',
      'Theme-based music selection'
    ],
    icon: '🎉'
  },
  {
    id: 'karaoke',
    title: 'Karaoke Sound Services',
    description: 'Complete karaoke setup with a vast collection of tracks.',
    features: [
      'Large karaoke track collection',
      'Professional wireless microphones',
      'High-quality speakers and monitors',
      'Lyrics display system',
      'Song request system'
    ],
    icon: '🎤'
  },
  {
    id: 'wedding',
    title: 'Wedding Sound Services',
    description: 'Make your special day perfect with our professional wedding sound services.',
    features: [
      'Ceremony and reception music',
      'Wireless microphones for speeches',
      'Dance floor entertainment',
      'Personalized wedding playlists',
      'Professional sound technician'
    ],
    icon: '💒'
  },
  {
    id: 'live',
    title: 'Live Streaming Services',
    description: 'Professional live streaming setup for your events and performances.',
    features: [
      'Multi-platform streaming',
      'High-quality audio integration',
      'Professional streaming setup',
      'Real-time interaction',
      'Event recording available'
    ],
    icon: '📡'
  }
]

export function Services({ onBookService }: ServicesProps) {
  return (
    <section className="services">
      <h2>Our Services</h2>
      <p className="services-intro">
        Professional sound services in Tzaneen & Limpopo Area since 2022. 
        We bring communities together through quality sound and music.
      </p>
      <div className="services-grid">
        {services.map(service => (
          <div key={service.id} className="service-card" id={service.id}>
            <div className="service-header">
              <span className="service-icon">{service.icon}</span>
              <h3>{service.title}</h3>
            </div>
            <p className="service-description">{service.description}</p>
            <ul className="service-features">
              {service.features.map((feature, index) => (
                <li key={index}>
                  <span className="feature-bullet">•</span>
                  {feature}
                </li>
              ))}
            </ul>
            <button 
              className="book-button"
              onClick={() => onBookService(service.id)}
            >
              Book Now
            </button>
          </div>
        ))}
      </div>
      <div className="services-cta">
        <p>Looking for a custom solution?</p>
        <a href="tel:0815436748" className="contact-button">
          Contact Us
        </a>
      </div>
    </section>
  )
} 